import React from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";

import {
  Form,
  FormGroup,
  Input,
  Button,
  Select,
  ModalView,
  LoadingIndicator
} from "../../simple";
import SVG from "../../SVG";
import {
  validate as validator,
  validationRules
} from "../../../helpers/validate";
import "../CreateAudienceDescription/styles.scss";

function validate(value) {
  const result = validator(value, validationRules.exist);
  return result;
}

export default class SelectClientBeforePush extends React.Component {
  constructor(props) {
    super(props);
    const { client, name, id } = props.data;
    this.state = {
      data: {
        id,
        name: name || "",
        clientsId: client ? client.id : null
      },
      validation: {
        name: false,
        clientsId: false
      }
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(name, value) {
    this.setState(({ data, validation }) => ({
      data: { ...data, [name]: value },
      validation: {
        ...validation,
        [name]: !validate(value)
      }
    }));
  }

  handleSubmit(evt) {
    const { data } = this.state;
    const { handleSubmit } = this.props;
    evt.preventDefault();
    return handleSubmit(data);
  }

  render() {
    const {
      data: { name, clientsId },
      validation
    } = this.state;
    const { clients, canChangeClient, type, modalTitle } = this.props;

    const clientsList = [...clients];

    const isSubmitDisabled = !!(!clientsId || !name);

    const selectedClient = clientsList.find(c => c.id === clientsId);

    return (
      <Form onSubmit={this.handleSubmit} className="audience-form">
        <h2 className="title">{modalTitle}</h2>
        {/* <span className="description">{descriptionText}</span> */}
        <FormGroup>
          {type === "audience" ? (
            <Input
              type="text"
              value={name}
              label="Name"
              name="name"
              placeholder="Name"
              invalid={validation.name}
              handleChange={this.handleChange}
              required
              fieldError="Please, provide a valid name"
            />
          ) : null}

          <Select
            value={
              selectedClient
                ? { value: selectedClient.id, label: selectedClient.name }
                : ""
            }
            label="Client"
            placeholder="Client"
            optionLabel="name"
            optionValue="id"
            options={clientsList}
            name="clientsId"
            handleChange={this.handleChange}
            isDisabled={!canChangeClient}
            required
          />
        </FormGroup>
        {this.props.isLoading ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <LoadingIndicator />
          </div>
        ) : (
          <Button
            type="submit"
            style={{ minWidth: "228px" }}
            className="button"
            disabled={isSubmitDisabled}
          >
            Pick platform
            <SVG.Arrow className="icon" />
          </Button>
        )}
      </Form>
    );
  }
}

SelectClientBeforePush.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string,
    client: PropTypes.shape({
      id: PropTypes.string
    }),
    id: PropTypes.string
  }),
  clients: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  handleSubmit: PropTypes.func.isRequired,
  canChangeClient: PropTypes.bool,
  type: PropTypes.string,
  modalTitle: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired
};

SelectClientBeforePush.defaultProps = {
  data: {},
  canChangeClient: false,
  type: ""
};

function ModalSelectClientBeforePush(props) {
  const {
    modalTitle,
    changeModalState,
    isOpen,
    clients,
    data,
    handleSubmit,
    canChangeClient,
    type,
    isLoading,
    ...restProps
  } = props;
  return (
    <ModalView
      toggle={changeModalState}
      handleClose={changeModalState}
      isOpen={isOpen}
      {...restProps}
    >
      <SelectClientBeforePush
        canChangeClient
        data={data}
        clients={clients}
        handleSubmit={handleSubmit}
        type={type}
        modalTitle={modalTitle}
        isLoading={isLoading}
      />
    </ModalView>
  );
}

ModalSelectClientBeforePush.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  withFileUpload: PropTypes.bool,
  data: PropTypes.shape({
    id: PropTypes.string.isRequired
  }).isRequired,
  clients: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  changeModalState: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  canChangeClient: PropTypes.bool,
  type: PropTypes.string,
  isAttachFileLoading: PropTypes.bool.isRequired,
  isLoadingPresets: PropTypes.bool.isRequired,
  customerAnalysisError: PropTypes.bool.isRequired,
  modalTitle: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired
};

ModalSelectClientBeforePush.defaultProps = {
  withFileUpload: false,
  canChangeClient: true,
  type: ""
};

const mapStateToProps = ({ audiences }) => ({
  isLoading: audiences.isLoading
});

const connectedModalSelectClientBeforePush = connect(
  mapStateToProps,
  null
)(ModalSelectClientBeforePush);

export { connectedModalSelectClientBeforePush as ModalSelectClientBeforePush };
